import React, { Component } from "react";
import AdmissionPrintRequest from "../Components/AdmissionPrint/AdmissionPrintRequest";

class AdmissionPrintRequestPage extends Component {
  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  Reprint Admission Receipt
                </div>
              </h3>
              <hr />

              <AdmissionPrintRequest {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdmissionPrintRequestPage;
